import Login from '../pages/login';
import Products from '../pages/products';
import ProductDetails from '../pages/productDetails';
import PageNotFound from '../pages/pageNotFound'
import AddAdmin from '../pages/addAdmin';
import Users from '../pages/users';
import Agents from '../pages/agents';
import Leads from '../pages/leads';
import UploadedOrders from '../pages/uploadedOrders';
import Payments from '../pages/payments';
import Orders from '../pages/orders';
import Categories from '../pages/categories';
import Delivery from '../pages/delivery';
import OrderDetails from '../pages/orderDetails';
import Banners from '../pages/banners';
import CombineProducts from '../pages/combineProducts';
import AppUsers from '../pages/appUsers';
import AppUserDetails from '../pages/appUserDetails';
import Offers from "../pages/offers";
import HotLooks from "../pages/hotlooks";
import Broadcast from '../pages/Broadcast';
import purchaseHistory from '../pages/purchaseHistory';
import Version from '../pages/version'; 
import Pincode from '../pages/pinCode'; 



const publicRoutes = [
    {
        component: Login,
        path: "/",
        exact: true,
    },
    {
        component: PageNotFound,
        path: '/not-found',
        exact: true,
    }
];

const privateRoutes = [
    {
        component: Products,
        path: "/products",
        exact: true,
    },
    {
        component: ProductDetails,
        path: "/product/:id",
        exact: true
    },
    {
        component: AddAdmin,
        path: '/add-user/:userType',
        exact: true,
    },
    {
        component: Users,
        path: "/users/:userType",
        exact: true,
    },
    {
        component: Agents,
        path: "/franchise",
        exact: true,
    },
    {
        component: Leads,
        path: "/leads/:id/",
        exact: true,
    },
    {
        component: UploadedOrders,
        path: "/uploaded-orders",
        exact: true,
    },
    {
        component: Payments,
        path: "/payments",
        exact: true,
    },
    {
        component: Orders,
        path: "/orders",
        exact: true,
    },
    {
        component: Categories,
        path: "/categories",
        exact: true,
    },
    {
        component: Delivery,
        path: "/delivery",
        exact: true,
    },
    {
        component: OrderDetails,
        path: "/order/:id",
        exact: true,
    },
    {
        component: Banners,
        path: "/banners",
        exact: true,
    },
    {
        component: CombineProducts,
        path: "/combine-products",
        exact: true,
    },
    {
        component: AppUsers,
        path: "/app-users",
        exact: true,
    },
    {
        component: AppUserDetails,
        path: "/app-user/:id",
        exact: true,
    },
    {
        component: Offers,
        path: "/offers",
        exact: true,
    },
    {
        component: HotLooks,
        path: "/hotlooks",
        exact: true,
    },
    {
        component: Broadcast,
        path: "/broadcast",
        exact: true,
    },
    {
        component: Version,
        path: "/addversion",
        exact: true,
    },
    {
        component: Pincode,
        path: "/pincode",
        exact: true,
    },
    {
        component: purchaseHistory,
        path: "/purchase-history/:id/:name",
        exact: true,
    },
];

export {
    publicRoutes,
    privateRoutes,
};